import React from 'react';
import ReactDOM from 'react-dom';

import App from '@project/containers/App';
import { loadRuntimeConfig } from './utils/config';

// Инициализируем runtime конфигурацию при загрузке приложения
const initApp = async () => {
  try {
    // Загружаем runtime конфигурацию
    await loadRuntimeConfig();
    
    // Рендерим приложение
    ReactDOM.render(
      <App />,
      document.getElementById('root')
    );
  } catch (error) {
    console.error('Failed to initialize app:', error);
    // Рендерим приложение даже если конфигурация не загрузилась
    ReactDOM.render(
      <App />,
      document.getElementById('root')
    );
  }
};

initApp();
